import { FieldTypes } from '../constants/FieldTypes'
import { DropdownField, FieldMap, PhoneField, TextField } from '../types'
import { addFieldRow } from './utils'

export const employmentStatusField: DropdownField = {
  placeholder: 'Employment Status',
  type: FieldTypes.DROPDOWN,
  options: [
    { id: 'employed', text: 'Employed' },
    { id: 'self-employed', text: 'Self-Employed' },
    { id: 'out-of-work', text: 'Out of Work' },
    { id: 'student', text: 'Student' },
    { id: 'retired', text: 'Retired' },
    { id: 'stay-at-home-parent', text: 'Stay-at-Home Parent' },
    { id: 'unable-to-work', text: 'Unable to Work' },
  ],
}

export const occupationField: TextField = {
  placeholder: 'Occupation',
  type: FieldTypes.TEXT,
  condition: value => {
    const employmentStatus = value?.employmentStatus
    return employmentStatus === 'self-employed' || employmentStatus === 'employed'
  },
}

export const employerField: TextField = {
  placeholder: 'Employer',
  type: FieldTypes.TEXT,
  condition: value => {
    const employmentStatus = value?.employmentStatus
    return employmentStatus === 'employed'
  },
}

export const employerPhoneField: PhoneField = {
  placeholder: 'Employer Phone',
  type: FieldTypes.PHONE,
  condition: value => {
    const employmentStatus = value?.employmentStatus
    return employmentStatus === 'employed'
  },
}

export const schoolField: TextField = {
  placeholder: 'School',
  type: FieldTypes.TEXT,
  condition: value => {
    const employmentStatus = value?.employmentStatus
    return employmentStatus === 'student'
  },
}

export const employmentField: FieldMap = {
  name: 'Employment',
  children: {
    employmentStatus: employmentStatusField,
    occupation: occupationField,
    employer: addFieldRow(employerField, { index: 0, flex: 1 }),
    employerPhone: addFieldRow(employerPhoneField, { index: 0, flex: 1 }),
    school: schoolField,
  },
}
